import AddForm from "../components/conversions/AddForm";
import ConversionDetails from "../components/conversions/ConversionDetails";
import GeneratedReport from "../components/reports/generatedReportSection";
import ReportsDetailSection from "../components/reports/reportsDetailSection";
import MainLayout from "../layout";
import AboutUs from "../pages/AboutUs";
import Campaigns from "../pages/Campaigns";
import ComingInFuture from "../pages/ComingInFuture";
import Conversions from "../pages/Conversions";
import Dashboard from "../pages/Dashboard";
import LearnAboutTrialPartners from "../pages/LearnAboutTrialPartners";
// import Dashboard from "../pages/Dashboard";
import ManageDataSource from "../pages/ManageDataSource";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Profile from "../pages/Profile";
import Reports from "../pages/Reports";
import SendFeedback from "../pages/SendFeedback";
import routeConstants from "../utils/routeConstants";
import AuthGuard from "./AuthGaurds";

const MainRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      {/* use '/dashboard' to access login page */}
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: routeConstants.dashboard,
      element: <Dashboard />,
    },
    {
      path: routeConstants.myProfile,
      element: <Profile />,
    },
    {
      path: routeConstants.campaigns,
      element: <Campaigns />,
    },
    {
      path: routeConstants.manageDataSource,
      element: <ManageDataSource />,
    },
    {
      path: routeConstants.reports,
      element: <ReportsDetailSection />,
    },
    {
      path: routeConstants.generateReports,
      element: <Reports />,
    },
    {
      path: routeConstants.generatedReport,
      element: <GeneratedReport />,
    },
    {
      path: routeConstants.privacyPolicy,
      element: <PrivacyPolicy />,
    },
    {
      path: routeConstants.aboutUs,
      element: <AboutUs />,
    },
    {
      path: routeConstants.learnAboutTrialPartners,
      element: <LearnAboutTrialPartners />,
    },
    {
      path: routeConstants.sendFeedback,
      element: <SendFeedback />,
    },
    {
      path: routeConstants.conversions,
      element: <Conversions />,
    },
    {
      path: routeConstants.conversionDetails,
      element: (
        // <ConversionDetails
        //   title="Diabetes Management"
        //   link="https://diabetes_management.stream123.net/registration/go/abcde12345"
        // />
        <AddForm />
      ),
    },
    {
      path: "*",
      element: <ComingInFuture />,
    },
  ],
};

export default MainRoutes;
